export default {
    race_10000: 'All',
    race_1: 'All Population',
    race_2: 'Hispanic, Any race',
    race_3: 'Non-Hispanic, Other races',
    race_4: 'Non-Hispanic, Black',
    race_5: 'Non-Hispanic, White',
    race_6: 'Non-Hispanic, American Indian or Alaskan Native',
    race_7: 'Non-Hispanic, Asian or Pacific Islander',
    race_8: 'Non-Hispanic, Native Hawaiian and Other Pacific Islander',
    race_9: 'Non-Hispanic, Asian',
    race_10: 'Non-Hispanic, White alone',
    race_11: 'Non-Hispanic, Black alone',
    race_12: 'Non-Hispanic, American Indian, Alaskan Native alone',
    race_13: 'Non-Hispanic, Asian alone',
    race_14: 'Non-Hispanic, Native Hawaiian and Other Pacific Islander alone',
    race_15: 'Non-Hispanic, Multiracial',
    race_17: 'Non-Hispanic, neither Black alone nor White alone',
};
